module.exports = __webpack_public_path__ + "static/media/da42.6f42fde6.png";